import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from '../uitk-calendar.css';

// Modules
var getClassNameList = classNames.bind(styles);
var edgeSelectionClasses = {
    StartAndEndSameDayEdge: 'uitk-calendar-day-selection-edge-same-day',
    StartRangeEdge: 'uitk-calendar-day-selection-edge-start',
    SingleDate: 'uitk-calendar-day-selection-edge-start',
    EndRangeEdge: 'uitk-calendar-day-selection-edge-end',
    UnconfirmedEndRangeEdge: 'uitk-calendar-day-selection-edge-unconfirmed-end',
    UnconfirmedStartAndEndSameDayEdge: 'uitk-calendar-day-selection-edge-unconfirmed-same-day'
};
var getEdgeSelectorClass = function (selectionType) { return edgeSelectionClasses[selectionType] || ''; };
var DaySelectionEdge = function (props) {
    var selectionType = props.selectionType, children = props.children;
    var classes = React.useMemo(function () { return getClassNameList(getEdgeSelectorClass(selectionType)); }, [selectionType]);
    return classes ? React.createElement("div", { className: classes }, children) : React.createElement(React.Fragment, null, children);
};

export { DaySelectionEdge as default };
